/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { AsyncTaskFunction } from 'ember-concurrency';
import LogModel from 'cio/models/log';
import CustomerModel from 'cio/models/customer';

interface LogsListArgs {
  name: string;
  type: string;
  logs: LogModel[];
  continuation: string;
  isAnonymous: boolean;
  selected?: string;
  customer?: CustomerModel;
  isIndividualPersonActivity?: boolean;
  fetchLogs: AsyncTaskFunction<void, never[]>;
  fetchMore: AsyncTaskFunction<void, never[]>;
}

export default class LogsList extends Component<LogsListArgs> {
  @tracked isShowingSendTestEventModal = false;
  @tracked log: LogModel | null = null;

  get hasAnyFilters() {
    return !isEmpty(this.args.type) || !isEmpty(this.args.name);
  }

  // For anonymous logs, there's no processed_at column.
  get columns() {
    return this.args.isAnonymous ? 4 : 5;
  }

  @action
  onSendTestWithLog(log: LogModel) {
    this.log = log;
    this.isShowingSendTestEventModal = true;
  }
}
